import React, { Component } from "react";
import Form from "../components/Form/Form";
import templates from "../components/FormTemplates";
import dynamicPortal from "../utils/dynamicPortal";
import connection from "../api/config/connection";

export class DiscountCalculatorPortal extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return dynamicPortal.load(
      ".js-react-discount-calculator",
      (config, node) => {
        config.submit.method = "POST";
        config.submit.async = true;
        return (
          <Form
            config={config}
            templates={templates}
            axios={connection.instance()}
            onSubmitted={async (response) =>
              await this.handleSubmitted(response, config, node)
            }
            onError={(error) => this.handleError(error)}
          />
        );
      }
    );
  }

  async handleSubmitted(response, config, node) {
    const { culture } = config;

    node.getElementsByClassName("fullPriceIdentifier")[0].innerText =
      "€" +
      (Math.round(response.data.FullPrice * 100) / 100).toLocaleString(
        culture,
        { maximumFractionDigits: 2, minimumFractionDigits: 2 }
      );
    node.getElementsByClassName("priceWithDiscountIdentifier")[0].innerText =
      "€" +
      (Math.round(response.data.PriceWithDiscount * 100) / 100).toLocaleString(
        culture,
        { maximumFractionDigits: 2, minimumFractionDigits: 2 }
      );
    node.getElementsByClassName("discountIdentifier")[0].innerText =
      "€" +
      (Math.round(response.data.Discount * 100) / 100).toLocaleString(culture, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
  }
}

export default DiscountCalculatorPortal;



// WEBPACK FOOTER //
// ./src/portals/DiscountCalculatorPortal.js